export default function customSelectTheme(defaultTheme) {
  return {
    ...defaultTheme,
    colors: {
      ...defaultTheme.colors,
      primary: "#384fbe",
      primary25: "#f6f6f6",
    },
  };
}
